import React, { ReactElement } from 'react';

import Link from 'atomic/link/link';
import { links } from './footer.links.data';

const FooterLinks: React.FC = () => (
    <ul className="footer__list">
        {links.map((link): ReactElement => (
            <li key={link.label} className="footer__list-item">
                <Link href={link.href} className="footer__link">
                    {link.label}
                </Link>
            </li>
        ))}
    </ul>
);

export default FooterLinks;
